<template>
	<label :class="['flex max-w-max', alignCenter ? 'items-center' : 'items-start']">
		<input
			v-model="inputValue"
			type="checkbox"
			:disabled="disabled"
			class="bg-white content-box shrink-0 flex items-center justify-center material-icons-outlined appearance-none cursor-pointer border border-dj-gray-light disabled:bg-dj-gray-transparency disabled:hover:border-dj-gray-light disabled:cursor-not-allowed hover:border-dj-gray checked:after:content-['done']"
			:class="[
				light
					? 'checked:bg-dj-white checked:after:text-base checked:after:text-dj-blue'
					: 'checked:bg-dj-blue checked:border-0 checked:after:text-base checked:after:text-white',
				small ? 'w-6 h-6 rounded-md' : 'w-8 h-8 rounded-normal',
				error ? 'border-2 border-dj-red hover:border-dj-red' : '',
			]"
		/>
		<!-- @slot Use this slot to set the checkbox text -->
		<span class="font-medium mt-1 ml-dj-20"><slot></slot></span>
	</label>
</template>

<script lang="ts">
import { computed, defineComponent } from "vue";

export default defineComponent({
	name: "BaseCheckbox",
	props: {
		modelValue: {
			type: Boolean,
			default: false,
		},
		light: {
			type: Boolean,
			default: false,
		},
		small: {
			type: Boolean,
			default: false,
		},
		disabled: {
			type: Boolean,
			default: false,
		},
		error: {
			type: Boolean,
			default: false,
		},
		alignCenter: {
			type: Boolean,
			default: false,
		},
	},
	emits: ["update:modelValue", "change"],
	setup(props, { emit }) {
		const inputValue = computed<boolean>({
			get() {
				return props.modelValue;
			},
			set(value) {
				emit("update:modelValue", value);
				emit("change", value);
			},
		});

		return {
			inputValue,
		};
	},
});
</script>
